export default __webpack_public_path__ + "static/media/info_btn_icon1.acd324da.svg";